import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { IAcademicsClassResponse } from '../../../../apis/academics/academics.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsClassesKey = 'get-academics-classes';

export type TAcademicsClassesParams = {
  page?: number;
  limit?: number;
  academicYear?: string;
  grade?: string;
  search?: string;
};

export const useAcademicsClassesHook = (
  params: TAcademicsClassesParams,
  options?: UseQueryOptions<IAcademicsClassResponse, TQueryError>
): UseQueryResult<IAcademicsClassResponse, TQueryError> => {
  const { getAcademicsClasses } = useAcademicsService();

  return useQuery<IAcademicsClassResponse, TQueryError>({
    queryKey: [getAcademicsClassesKey, params],
    queryFn: () => getAcademicsClasses(params),
    enabled: true,
    ...options,
  });
};
